import React from "react";

interface MailIconProps {
}

const MailIcon:React.FC<MailIconProps> = ({}) => {
    return (
        <svg viewBox="0 0 16 16" width="24" xmlns="http://www.w3.org/2000/svg" height="24" fill="none">
            <path d="M3.234 2.775C2.009 2.775.996 3.781.996 4.998v6c0 1.217 1.013 2.225 2.238 2.225h9.528c1.225 0 2.238-1.008 2.238-2.225v-6c0-1.217-1.013-2.223-2.238-2.223H3.234Zm0 1.795h9.528c.256 0 .437.174.437.428v6a.42.42 0 0 1-.437.436H3.234c-.256 0-.429-.182-.429-.436v-6c0-.254.173-.428.429-.428Zm1.012 1.135a.899.899 0 0 0-.732.518.9.9 0 0 0 .435 1.195l4.053 1.891 4.053-1.891a.9.9 0 0 0-.76-1.631L8.002 7.322 4.709 5.787a.9.9 0 0 0-.463-.082Z"/>
        </svg>
    )
}

export default MailIcon;